<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, maxLength, helpers } from '@vuelidate/validators';
import { useAlert } from 'dashboard/composables';
import { parseAPIErrorResponse } from 'dashboard/store/utils/api';
import { isValidPassword } from 'shared/helpers/Validators';
import FormButton from 'v3/components/Form/Button.vue';

export default {
  components: {
    FormButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      currentPassword: '',
      password: '',
      passwordConfirmation: '',
      isPasswordChanging: false,
      errorMessage: '',
      darkInputStyles: {
        borderRadius: '8px',
        padding: '8px 14px',
        fontSize: '16px',
        color: 'rgb(var(--gray-5))',
        borderColor: 'rgb(var(--gray-8))',
        fontWeight: '400',
        backgroundColor: 'rgb(var(--black-br))',
      },
    };
  },
  validations: {
    currentPassword: {
      required,
      minLength: minLength(6),
    },
    password: {
      minLength: minLength(6),
      isValidPassword: helpers.withMessage(
        function () {
          return this.$t('PROFILE_SETTINGS.FORM.PASSWORD.ERROR');
        },
        isValidPassword
      ),
    },
    passwordConfirmation: {
      minLength: minLength(6),
      isEqPassword(value) {
        if (value !== this.password) {
          return false;
        }
        return true;
      },
    },
  },
  computed: {
    isButtonDisabled() {
      return (
        !this.currentPassword ||
        !this.passwordConfirmation ||
        !this.v$.passwordConfirmation.isEqPassword
      );
    },
  },
  methods: {
    async changePassword() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        useAlert(this.$t('PROFILE_SETTINGS.FORM.ERROR'), {type: 'error'});
        return;
      }
      let alertMessage = this.$t('PROFILE_SETTINGS.PASSWORD_UPDATE_SUCCESS');
      try {
        await this.$store.dispatch('updateProfile', {
          password: this.password,
          password_confirmation: this.passwordConfirmation,
          current_password: this.currentPassword,
        });
      } catch (error) {
        const backendMsg = parseAPIErrorResponse(error) || '';
        const lowerMsg = backendMsg.toLowerCase();
        const complexityHint = ['uppercase', 'lowercase', 'number', 'special', 'must contain'];
        if (complexityHint.some(key => lowerMsg.includes(key))) {
          alertMessage = this.$t('PROFILE_SETTINGS.FORM.PASSWORD.ERROR');
        } else {
          alertMessage = backendMsg || this.$t('RESET_PASSWORD.API.ERROR_MESSAGE');
        }
      } finally {
        useAlert(alertMessage, {type: 'error'});
      }
    },
  },
};
</script>

<template>
  <form @submit.prevent="changePassword()">
    <div class="flex flex-col md:flex-row justify-between gap-3">
      <woot-input
        v-model="currentPassword"
        type="password"
        :styles="darkInputStyles"
        :class="{ error: v$.currentPassword.$error,'w-full': true  }"
        :label="$t('PROFILE_SETTINGS.FORM.CURRENT_PASSWORD.LABEL')"
        :placeholder="$t('PROFILE_SETTINGS.FORM.CURRENT_PASSWORD.PLACEHOLDER')"
        :error="`${
          v$.currentPassword.$error
            ? $t('PROFILE_SETTINGS.FORM.CURRENT_PASSWORD.ERROR')
            : ''
        }`"
        @input="v$.currentPassword.$touch"
        @blur="v$.currentPassword.$touch"
      />

      <woot-input
        v-model="password"
        type="password"
        :styles="darkInputStyles"
        :class="{ error: v$.password.$error,'w-full': true}"
        :label="$t('PROFILE_SETTINGS.FORM.PASSWORD.LABEL')"
        :placeholder="$t('PROFILE_SETTINGS.FORM.PASSWORD.PLACEHOLDER')"
        :error="`${
          v$.password.$error ? $t('PROFILE_SETTINGS.FORM.PASSWORD.ERROR') : ''
        }`"
        @input="v$.password.$touch"
        @blur="v$.password.$touch"
      />

      <woot-input
        v-model="passwordConfirmation"
        type="password"
        :styles="darkInputStyles"
        :class="{ error: v$.passwordConfirmation.$error,'w-full': true }"
        :label="$t('PROFILE_SETTINGS.FORM.PASSWORD_CONFIRMATION.LABEL')"
        :placeholder="
          $t('PROFILE_SETTINGS.FORM.PASSWORD_CONFIRMATION.PLACEHOLDER')
        "
        :error="`${
          v$.passwordConfirmation.$error
            ? $t('PROFILE_SETTINGS.FORM.PASSWORD_CONFIRMATION.ERROR')
            : ''
        }`"
        @input="v$.passwordConfirmation.$touch"
        @blur="v$.passwordConfirmation.$touch"
      />

      <!-- <FormButton
        type="submit"
        color-scheme="primary"
        variant="solid"
        size="large"
        :disabled="isButtonDisabled"
      >
        {{ $t('PROFILE_SETTINGS.FORM.PASSWORD_SECTION.BTN_TEXT') }}
      </FormButton> -->
    </div>
  </form>
</template>
